var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 3.33337C17.5466 3.33337 18.2664 4.01327 18.3301 4.87566L18.3346 5.00004V15C18.3346 15.8787 17.6548 16.5985 16.7924 16.6621L16.668 16.6667H3.33464C2.456 16.6667 1.73616 15.9868 1.67254 15.1244L1.66797 15V5.00004C1.66797 4.12141 2.34787 3.40157 3.21025 3.33795L3.33464 3.33337H16.668ZM16.668 6.17857L10.8851 11.9614C10.397 12.4495 9.60555 12.4495 9.11739 11.9614L3.33464 6.17857V15H16.668V6.17857ZM15.4895 5.00004H4.51304L10.0013 10.4883L15.4895 5.00004Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.c2d64ef821ae2775aba9f16b1baf488a.svg";
export { ForwardRef as ReactComponent };